import React from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const CustomDonutChart = ({ data, totalValue, title = "Total Distribution" }) => {
    const { t } = useTranslation();
    const COLORS = ['#10b981', '#f59e0b', '#ef4444', '#3b82f6', '#8b5cf6'];

    return (
        <div className="h-auto min-h-[300px] w-full bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center relative gap-4">
            <h3 className="w-full text-left text-gray-500 text-sm font-medium">{title}</h3>

            <div className="h-[180px] w-full relative">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            innerRadius={55}
                            outerRadius={75}
                            paddingAngle={5}
                            dataKey="value"
                            stroke="none"
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color || COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
                    </PieChart>
                </ResponsiveContainer>
                {/* Centered Total */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center pointer-events-none">
                    <span className="block text-gray-400 text-[10px] uppercase font-bold tracking-wider">{t('systemDashboard.common.total')}</span>
                    <span className="block text-xl font-extrabold text-gray-800">{totalValue}</span>
                </div>
            </div>

            {/* Legend */}
            <div className="w-full grid grid-cols-2 md:grid-cols-1 xl:grid-cols-2 gap-x-4 gap-y-2 text-[10px] md:text-xs">
                {data.map((entry, index) => (
                    <div key={index} className="flex items-center justify-between group">
                        <span className="flex items-center gap-1.5 truncate">
                            <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: entry.color || COLORS[index % COLORS.length] }}></span>
                            <span className="text-gray-500 group-hover:text-gray-900 transition-colors truncate">{entry.name}</span>
                        </span>
                        <span className="font-bold text-gray-700 ml-2">{entry.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomDonutChart;
